export const FORM_TEMPLATES = {
    default: {
        name: "Default",
        description: "Clean & minimal with indigo accents",
        primaryColor: "#6366f1",
        backgroundColor: "#ffffff",
        fontFamily: "Inter",
        borderRadius: 8,
        inputStyle: "bordered",
        buttonStyle: "rounded",
        shadow: "sm",
        containerWidth: 600,
        fieldSpacing: 16,
        fontSize: 14,
        labelColor: "#374151",
        inputBgColor: "#ffffff",
        inputBorderColor: "#d1d5db",
        buttonTextColor: "#ffffff",
        padding: 32,
        templateId: "default",
    },
    dark: {
        name: "Dark",
        description: "Modern dark theme with cyan highlights",
        primaryColor: "#06b6d4",
        backgroundColor: "#1a1a2e",
        fontFamily: "JetBrains Mono",
        borderRadius: 8,
        inputStyle: "filled",
        buttonStyle: "rounded",
        shadow: "md",
        containerWidth: 600,
        fieldSpacing: 18,
        fontSize: 14,
        labelColor: "#e2e8f0",
        inputBgColor: "#16213e",
        inputBorderColor: "#334155",
        buttonTextColor: "#ffffff",
        padding: 32,
        templateId: "dark",
    },
    colorful: {
        name: "Colorful",
        description: "Warm & playful with coral accents",
        primaryColor: "#f97316",
        backgroundColor: "#fff7ed",
        fontFamily: "Poppins",
        borderRadius: 12,
        inputStyle: "filled",
        buttonStyle: "pill",
        shadow: "lg",
        containerWidth: 600,
        fieldSpacing: 20,
        fontSize: 15,
        labelColor: "#9a3412",
        inputBgColor: "#ffffff",
        inputBorderColor: "#fed7aa",
        buttonTextColor: "#ffffff",
        padding: 36,
        templateId: "colorful",
    },
};

export const TEMPLATE_LIST = Object.entries(FORM_TEMPLATES).map(
    ([id, template]) => ({
        id,
        ...template,
    })
);

export const getTemplate = (id) => {
    return FORM_TEMPLATES[id] || FORM_TEMPLATES.default;
};
